// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"30762b4f","2296":"30762b4f","3799":"30762b4f","4364":"e18a9a6a","8615":"30762b4f"}[chunkId] + ".chunk.css";
};